'use strict'

import axios from 'axios'
import { Message, Loading } from 'element-ui'
import urlConfig from './config'
let loadingInstance = null
let loadingCount = 0;
function dealLoading(notLoading) {
    if (!notLoading) {
        //closeLoding();
        loadingCount++;
        loadingInstance = Loading.service({
            fullscreen: true,
            lock: true
        })

    }
}
function closeLoding() {
    loadingCount > 0 && loadingCount--;
    (loadingCount === 0) && loadingInstance && setTimeout(function(){loadingInstance.close()},100);
}

export default function request(json) {
    let { url, data, notLoading } = json;
    url=url || urlConfig.interfaceUrl;
        const token = sessionStorage.getItem('token')
        if (token) {
            data.header.token = token
        }
    dealLoading(notLoading)
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then((response) => {
                closeLoding()
               const code=response.data.header.returnCode;
                if ( (code== '100004'|| code==="100001") && (data.header.serviceCode!=='FLOW_ADD') ) {
                    window.location.href = '#/account/login'
                } else {
                    resolve(response)
                }
            })
            .catch((error) => {
                closeLoding();
                console.log(error)
                reject(error)
            })
    })

}
//上传url==加密
export const encodeUploadUrl = '/symphony-design/execute/encryptFileUpload'
//上传url==不加密
export const UploadUrl = '/symphony-design/execute/fileUpload'




// WEBPACK FOOTER //
// ./src/utils/request.js